export const toYYYYMMDD = (date) => date.toISOString().slice(0, 10);

export const addDay = (date, days) => date.getTime() + 24 * 60 * 60 * 1000 * days;

export const countOfNights = (checkIn, checkOut) => {
    const startDate = new Date(checkIn).setHours(0, 0, 0, 0);
    const endDate = new Date(checkOut).setHours(0, 0, 0, 0);
    return Math.round((endDate - startDate) / (24 * 60 * 60 * 1000));
};